<ion-row tappable (click)="goTo('my-cleanings')" [ngClass]="{'selectedButton': menuData?.route === '/my-cleanings' || menuData?.route === '/no-plan'}">
  <ion-col class="button-icon">
    <div class="icon-schedule"></div>
  </ion-col>
  <ion-col class="button-label">
    <tidy-text [body]="'Schedule'" />
  </ion-col>
</ion-row>

<ion-row class="todos-button" [ngClass]="{'selectedButton': menuData?.route === '/home' || menuData?.route === '/todos-settings-clicked'}">
  <ion-col class="button-icon" tappable (click)="goTo('home')">
    <div class="icon-todos"></div>
  </ion-col>
  <ion-col class="button-label" tappable (click)="goTo('home')">
    <tidy-text [body]="'TIDY To Dos'" />
  </ion-col>
  @if (menuData?.hasPlan) {
    <div class="todos-settings todos-settings" (click)="goTo('to-dos-settings')" [ngClass]="{'todos-settings-clicked': menuData?.route === '/to-dos-settings'}"></div>
  }
</ion-row>

<ion-row tappable (click)="goTo('address-info')" [ngClass]="{'selectedButton': menuData?.route === '/address-info'}">
  <ion-col class="button-icon">
    <div class="icon-entry"></div>
  </ion-col>
  <ion-col class="button-label">
    <tidy-text [body]="'Entry & Contact Info'" />
  </ion-col>
</ion-row>
